import React, { Component } from 'react';
import { Row, Col, Drawer } from 'antd';
import {
  MenuOutlined,
  GlobalOutlined,
  HomeOutlined,
  FieldTimeOutlined,
  ClusterOutlined,
  AimOutlined,
  BarChartOutlined,
} from '@ant-design/icons';
import resources from '../resources';
import languages from '../appdata/languages';
import StoreManager from '../appdata';

const isInAppWebView = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  return /FBAN|FBAV|Instagram|Line|Zalo|ZaloWebView|TikTok|Messenger|WebView/i.test(ua);
};


class Header extends Component {
  state = {
    visible: false,
    isMobile: window.innerWidth < 768,
    isWebView: false,
    isScrollHover: false,

  };

  componentDidMount() {
    window.addEventListener('resize', this.updateDevice);
    this.setState({ isWebView: isInAppWebView() });

  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDevice);
  }

  updateDevice = () => {
    this.setState({ isMobile: window.innerWidth < 768 });
  };


  render() {
    const { visible, isMobile } = this.state;
    const backgroundStyle = {
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      height: '90vh',
      color: '#212121',
      position: 'relative',
      overflow: 'hidden',
    };

    const titleStyle = {
      fontSize: isMobile ? 40 : 48,
      lineHeight: '1.2', // thêm line-height cho đẹp
      margin: 0,
      fontWeight: 700,
      color: "#212121",
      fontFamily: 'Inter28-Bold',

    };

    const subtitleStyle = {
      fontSize: 'clamp(14px, 2vw, 20px)',
      lineHeight: '1.5', // thêm line-height cho subtitle
      marginTop: 10,
      fontWeight: 600
    };

    const overlay = {
      position: 'absolute',
      inset: 0,
      background: 'rgba(0,0,0,0.3)',
      zIndex: 1,
    };
    const videoSrc = isMobile
      ? resources.video.headerVideoMobile
      : resources.video.headerVideoDesktop;

    const lg = StoreManager.appState.thisApp.state.currentLanguage;
    const lang = languages[lg].HeaderContent;

    return (
      <div style={backgroundStyle}>
        {!this.state.isWebView ? (
          <video
            autoPlay
            loop
            muted
            playsInline
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              zIndex: 0,
            }}
          >
            <source src={videoSrc} type="video/webm" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <img
            src={resources.images.BannerZaloMobile}
            alt="Banner"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              zIndex: 0,
            }}
          />
        )}



        <div style={{ maxWidth: 1040, margin: '0 auto', padding: isMobile ? '0 16px' : '60px 40px' }}>

          <Row style={{ position: 'relative', zIndex: 2, paddingTop: isMobile ? '12vh' : '8vh' }}>
            <Col xs={22} sm={20} md={16} lg={10} style={{ textAlign: 'left' }}>
              {lang.titleLines.map((line, idx) => (
                <h1 key={idx} style={titleStyle}>{line}</h1>
              ))}
              <p style={subtitleStyle}>{lang.subtitle}</p>
              <div
                onClick={this.props.onScrollDown}
                onMouseEnter={() => this.setState({ isScrollHover: true })}
                onMouseLeave={() => this.setState({ isScrollHover: false })}
                style={{
                  marginTop: 20,
                  width: 40,
                  height: 40,
                  borderRadius: '50%',
                  border: '1px solid #212121',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  backgroundColor: this.state.isScrollHover ? '#212121' : 'transparent',
                  transition: 'all 0.3s ease',
                }}
              >
                <span
                  style={{
                    fontSize: 18,
                    color: this.state.isScrollHover ? '#ffffff' : '#212121',
                    transition: 'color 0.3s ease',
                  }}
                >
                  ↓
                </span>
              </div>

            </Col>
          </Row>
        </div>
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            height: 120, // tùy chỉnh độ cao vùng chuyển tiếp
            background: 'linear-gradient(to bottom, rgba(255,255,255,0) 0%, #ffffff 100%)',
            zIndex: 2,
          }}
        ></div>


      </div>
    );
  }
}

export default Header;
